import type { ReactNode } from "react";
import { Loader2 } from "lucide-react";
import { Button, Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@bookdental/ui";

/** Confirmação de uma ação do admin: o que vai acontecer, os campos que ela pede e o botão. */
export function DialogoDeAcao({
  aberto,
  onFechar,
  titulo,
  descricao,
  children,
  rotulo,
  perigosa = false,
  pronto = true,
  ocupado = false,
  onConfirmar,
}: {
  aberto: boolean;
  onFechar: () => void;
  titulo: string;
  descricao: ReactNode;
  children?: ReactNode;
  rotulo: string;
  perigosa?: boolean;
  pronto?: boolean;
  ocupado?: boolean;
  onConfirmar: () => void;
}) {
  return (
    <Dialog open={aberto} onOpenChange={(v) => !v && onFechar()}>
      <DialogContent className="max-w-md border border-zinc-200 bg-white shadow-xl">
        <DialogHeader>
          <DialogTitle>{titulo}</DialogTitle>
          <DialogDescription>{descricao}</DialogDescription>
        </DialogHeader>
        {children && <div className="space-y-3">{children}</div>}
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={onFechar} disabled={ocupado}>
            Cancelar
          </Button>
          <Button
            onClick={onConfirmar}
            disabled={!pronto || ocupado}
            className={perigosa ? "bg-red-600 text-white hover:bg-red-700" : undefined}
          >
            {ocupado && <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" />}
            {rotulo}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
